import React from 'react';
import { oneOf } from 'prop-types';
import styled from 'styled-components';

const className = (strings, props) => {
  const classNames = [
    'subtitle'
  ]
    .concat(
      [
        'size'
      ]
        .map((name) => props[name] ? `is-${props[name]}` : null)
        .filter((className) => !!className)
    )
    .concat(
      [
        'color'
      ]
        .map((name) => props[name] ? `has-text-${props[name]}` : null)
        .filter((className) => !!className)
    )
    .join(' ');

  return classNames;
};

const H1Subtitle = styled.h1.attrs((props) => ({
  className: className`${props}`
}))``;

const H2Subtitle = styled.h2.attrs((props) => ({
  className: className`${props}`
}))``;

const H3Subtitle = styled.h3.attrs((props) => ({
  className: className`${props}`
}))``;

const H4Subtitle = styled.h4.attrs((props) => ({
  className: className`${props}`
}))``;

const H5Subtitle = styled.h5.attrs((props) => ({
  className: className`${props}`
}))``;

const H6Subtitle = styled.h6.attrs((props) => ({
  className: className`${props}`
}))``;

const Subtitle = ({ size, children, ...props }) => {
  switch (size) {
    case '1':
      return (
        <H1Subtitle size={size} {...props}>{children}</H1Subtitle>
      );

    case '2':
      return (
        <H2Subtitle size={size} {...props}>{children}</H2Subtitle>
      );

    case '3':
      return (
        <H3Subtitle size={size} {...props}>{children}</H3Subtitle>
      );

    case '4':
      return (
        <H4Subtitle size={size} {...props}>{children}</H4Subtitle>
      );

    case '5':
      return (
        <H5Subtitle size={size} {...props}>{children}</H5Subtitle>
      );

    case '6':
      return (
        <H6Subtitle size={size} {...props}>{children}</H6Subtitle>
      );

    default:
      throw new Error(`subtitle of size ${size} is not supported`);
  }
};

Subtitle.propTypes = {
  size: oneOf(
    [
      '1',
      '2',
      '3',
      '4',
      '5',
      '6'
    ]
  ).isRequired,
  color: oneOf(
    [
      'white',
      'black',
      'light',
      'dark',
      'primary',
      'info',
      'link',
      'success',
      'warning',
      'danger',
      'black-bis',
      'black-ter',
      'grey-darker',
      'grey-dark',
      'grey',
      'grey-light',
      'grey-lighter',
      'white-ter',
      'white-bis'
    ]
  )
};

Subtitle.defaultProps = {
  color: undefined
};

export default Subtitle;
